/**
 * AnchorFormHandler — branche t="form" de Anchor (ha/448).
 *
 * Soumet `data` via `dataRepo.saveForm` puis route la réponse via dispatchResponse :
 * reload/success/app → `reloadApp({id: response.id})` (cf. legacy processForm).
 * Aucun changement de comportement.
 */

import { toMap, log, getDataRepository, getWebPageService } from "../../../HA";
import { dispatchResponse } from "../Service/ResponseDispatcher";

export function handleAnchorForm(data: any): void {
    getDataRepository().saveForm(data).then((response: Map<any, any>) => {
        const reloadById = (r: Map<any, any>) =>
            getWebPageService().reloadApp(toMap({ id: r.get("id") }));
        dispatchResponse(response, {
            handlers: {
                reload:  reloadById,
                success: reloadById,
                app:     reloadById,
            },
        });
    }).catch((reason: any) => {
        log(["form error", reason]);
    });
}
